import React from 'react';
import ContactForm from '../ContactFrom/ContactForm';
import { useTranslation } from 'react-i18next';

const Contactpage = () => {
    const { t } = useTranslation();

    return (
        <section className="wpo-contact-pg-section section-padding">
            <div className="container">
                <div className="row">
                    <div className="col col-lg-10 offset-lg-1">
                        <div className="office-info">
                            <div className="row">
                                <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                                    <div className="office-info-item">
                                        <div className="office-info-icon">
                                            <div className="icon">
                                                <i className="fi flaticon-location-1"></i>
                                            </div>
                                        </div>
                                        <div className="office-info-text">
                                            <h2>{t('contact1.addressTitle')}</h2>
                                            <p>{t('contact1.addressValue')}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                                    <div className="office-info-item">
                                        <div className="office-info-icon">
                                            <div className="icon">
                                                <i className="fi flaticon-email"></i>
                                            </div>
                                        </div>
                                        <div className="office-info-text">
                                            <h2>{t('contact1.emailTitle')}</h2>
                                            <p><br/>{t('contact1.emailValue')}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                                    <div className="office-info-item">
                                        <div className="office-info-icon">
                                            <div className="icon">
                                                <i className="fi flaticon-phone-call"></i>
                                            </div>
                                        </div>
                                        <div className="office-info-text">
                                            <h2> {t('contact1.phoneTitle')}</h2>
                
                                            <p><br/>{t('contact1.phoneValue')}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wpo-contact-title">
                            <h2>{t('contact1.formTitle')}</h2>
                            <p>{t('contact1.formSubtitle')}</p>
                        </div>
                        <div className="wpo-contact-form-area" style={{marginBottom:'20px'}}>
                            <ContactForm />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Contactpage;
